import { render, staticRenderFns } from "./SimpleCollapse.vue?vue&type=template&id=1fb2fa0a"
import script from "./SimpleCollapse.vue?vue&type=script&lang=js"
export * from "./SimpleCollapse.vue?vue&type=script&lang=js"
import style0 from "./SimpleCollapse.vue?vue&type=style&index=0&id=1fb2fa0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports